import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ReportSelectionOption } from '~/shared/utils/types';

import {
  apiFilterKey,
  reportsDateFilterKey,
  reportsRefreshStateKey,
} from '../../common/serachParamKeys';

const OPTIMIZATION_TABLE_SORT_KEY = 'sort_field';

interface UseReportsSearchParamsHandlersArgs {
  setPageOffset: (offset: string) => void;
}

export function useReportsSearchParamsHandlers({
  setPageOffset,
}: UseReportsSearchParamsHandlersArgs) {
  const [, setSearchParams] = useSearchParams();

  const handleDateFilterChange = useCallback(
    (filter: { title: string }) => {
      setPageOffset('0');
      setSearchParams(
        (params) => {
          params.set(reportsDateFilterKey, filter.title);
          return params;
        },
        { replace: true }
      );
    },
    [setPageOffset, setSearchParams]
  );

  const handleBaseFiltersChange = useCallback(
    (newFilters: ReportSelectionOption[]) => {
      setPageOffset('0');
      setSearchParams(
        (params) => {
          params.set(apiFilterKey, JSON.stringify(newFilters));
          return params;
        },
        { replace: true }
      );
    },
    [setPageOffset, setSearchParams]
  );

  const handleRefreshStateChange = useCallback(
    (item: { title: string }) => {
      setSearchParams(
        (params) => {
          params.set(reportsRefreshStateKey, item.title);
          return params;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const handleChartDateFilterChange = useCallback(
    (filter: { title: string }) => {
      setSearchParams(
        (params) => {
          params.set(reportsDateFilterKey, filter.title);
          return params;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const handleOptimizationTableSortChange = useCallback(
    (newSort: { field: string; dir: 'desc' | 'asc' }) => {
      setPageOffset('0');
      setSearchParams(
        (params) => {
          params.set(OPTIMIZATION_TABLE_SORT_KEY, JSON.stringify(newSort));
          return params;
        },
        { replace: true }
      );
    },
    [setPageOffset, setSearchParams]
  );

  return {
    handleDateFilterChange,
    handleBaseFiltersChange,
    handleRefreshStateChange,
    handleChartDateFilterChange,
    handleOptimizationTableSortChange,
  };
}
